import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {},
        redirect: null, // để xử lý cho breadcrumb
        activeDashboard: '0',
        breadcrumbs: [],
    },
    mutations: {
        setUser(state, data) {
            state.user = data;
        },
        setRedirect(state, data){
            if(data === null){
                state.redirect = '';
            }else{
                try{
                    let redirect = JSON.parse(atob(data));
                    let url = '?';
                    for(const key in redirect){
                        url += key + '=' + redirect[key] + '&'
                    }
                    state.redirect = url.slice(0, -1);
                }catch(e){
                    state.redirect = '';
                }
            }
        },
        setActiveDashboard(state, data){
            state.activeDashboard = data;
        },
        setBreadcrumbs(state, data){
            state.breadcrumbs = [];
            for (const key in data) {
                state.breadcrumbs.push(data[key]);
            }
        },
    },
    actions: {
    },
    modules: {
    }
})
